import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { FaSquarePlus, FaTrashCan } from "react-icons/fa6";
import { formReportServices } from "../../../../APIServices/formReportServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const InsertHeaderDetails = ({ type }) => {
  const [loader, setLoader] = useState("");

  const [titles, setTitles] = useState([{ id: 1, text: "" }]);

  const handleAddTitle = () => {
    setTitles([...titles, { id: titles.length + 1, text: "" }]);
  };

  const handleRemoveTitle = (id) => {
    if (titles.length > 1) {
      setTitles(titles.filter((title) => title.id !== id));
    }
  };

  const handleTitleChange = (id, newText) => {
    setTitles(
      titles.map((title) =>
        title.id === id ? { ...title, text: newText } : title
      )
    );
  };

  const findReportStudyMetadataData = async () => {
    setLoader(true);
    let data = await formReportServices.findReportStudyMetadataData(
      type
    );
    setTitles(data?.data?.headerData || [{ id: 1, text: "" }]);
    setLoader(false);
  };

  const addUpdateReportStudyMetadata = async (e) => {
    let datas = {};
    datas.type = type;
    datas.headerData = titles;
    let data = await formReportServices.addUpdateReportStudyMetadata(datas);
    if (data?.statusCode === 200) {
      findReportStudyMetadataData();
    }
  };

  useEffect(() => {
    findReportStudyMetadataData();
  }, []);
  return (
    <>
      {loader ? (
        <PageLoader/>
      ) : (
        <div className="py-2 px-3">
          <Form.Label className="mb-1 fw-bold">Add Header Title</Form.Label>
          {titles?.length === 10 ? (
            ""
          ) : (
            <FaSquarePlus
              className="ms-1 CP"
              title="Add More Title"
              onClick={handleAddTitle}
            />
          )}

          {titles?.map((title, index) => (
            <div className="hstack gap-2 mb-2" key={title.id}>
              <Form.Control
                type="text"
                placeholder={`Enter Header Title ${index + 1}`}
                value={title.text}
                onChange={(e) => handleTitleChange(title.id, e.target.value)}
              />
              <FaTrashCan
                className="text-danger"
                onClick={() => handleRemoveTitle(title.id)}
                style={{
                  cursor: titles.length === 1 ? "not-allowed" : "pointer",
                }}
              />
            </div>
          ))}
          <div className="text-end">
            <button
              className="updateProfile"
              onClick={() => addUpdateReportStudyMetadata()}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InsertHeaderDetails;
